{% block acris_blog_list %}
    <sw-page class="acris-blog-list">
        {% block acris_blog_list_search_bar %}
            <template #search-bar>
                <sw-search-bar initialSearchType="acris_blog"
                               :placeholder="$tc('acris-blog.general.placeholderSearchBar')"
                               :initialSearch="term"
                               @search="onSearch">
                </sw-search-bar>
            </template>
        {% endblock %}

        {% block acris_blog_list_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_blog_list_smart_bar_header_title %}
                    <h2>
                        {% block acris_blog_list_smart_bar_header_title_text %}
                            {{ $tc('acris-blog.list.textHeadline') }}
                        {% endblock %}

                        {% block acris_blog_list_smart_bar_header_amount %}
                            <span v-if="!isLoading" class="sw-page__smart-bar-amount">
                        ({{ total }})
                        </span>
                        {% endblock %}
                    </h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_list_smart_bar_language %}
            <template #language-switch>
                <sw-language-switch @on-change="onChangeLanguage"></sw-language-switch>
            </template>
        {% endblock %}

        {% block acris_blog_list_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_blog_list_smart_bar_actions_add %}
                    <mt-button variant="primary" @click="$router.push({ name: 'acris.blog.create' })" size="default">
                        {{ $tc('acris-blog.list.buttonAdd') }}
                    </mt-button>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_list_cardview %}
            <template #content>
                <div class="acris-blog-list__content">
                    {% block acris_blog_list_content %}
                        <sw-entity-listing class="acris-blog-list-grid"
                                           v-if="items && total > 0"
                                           show-selection
                                           :items="items"
                                           :repository="blogRepository"
                                           detailRoute="acris.blog.detail"
                                           :isLoading="isLoading"
                                           :columns="columns"
                                           :sort-by="sortBy"
                                           :sort-direction="sortDirection"
                                           @column-sort="onSortColumn"
                                           @page-change="onPageChange"
                                           @update-records="updateRecords"
                                           @selection-change="selectionChange">

{#                            {% block acris_blog_list_grid_columns_active %}#}
{#                                <template #column-active="{ item, isInlineEdit }">#}
{#                                    <template v-if="!isInlineEdit">#}
{#                                        {% block acris_blog_list_grid_columns_active_active %}#}
{#                                            <mt-icon name="regular-checkmark-xs" size="16px" v-if="item.active"#}
{#                                                     class="is--active"></mt-icon>#}
{#                                            <mt-icon name="regular-times-s" size="16px" v-else class="is--inactive"></mt-icon>#}
{#                                        {% endblock %}#}
{#                                    </template>#}

{#                                    {% block acris_blog_list_grid_columns_active_editor %}#}
{#                                        <template v-else>#}
{#                                            <sw-checkbox-field#}
{#                                                      v-model:value="item.active"#}
{#                                                      slot="inline-edit">#}
{#                                            </sw-checkbox-field>#}
{#                                        </template>#}
{#                                    {% endblock %}#}
{#                                </template>#}
{#                            {% endblock %}#}

                            {% block acris_blog_list_grid_columns_author %}
                                <template #column-author="{ item, isInlineEdit }">
                                    <template v-if="item && item.blogAuthor && (item.blogAuthor.firstName || item.blogAuthor.lastName)">
                                        <template v-if="!isInlineEdit">
                                            <router-link
                                                    :to="{ name: 'acris.blog.author.detail', params: { id: item.blogAuthor.id } }">
                                                {{ item.blogAuthor.firstName || '' }} {{ item.blogAuthor.lastName || '' }}
                                            </router-link>
                                        </template>
                                        <template v-else>
                                            {{ item.blogAuthor.firstName || '' }} {{ item.blogAuthor.lastName || '' }}
                                        </template>
                                    </template>
                                </template>
                            {% endblock %}

                            {% block  acris_blog_list_grid_columns_groups %}
                                <template #column-groups="{ item, isInlineEdit }">
                                    <div v-bind:class="{ 'acris-no-rule' : item.blogGroups.length == 0}">
                                        <sw-label
                                                v-for="group in item.blogGroups"
                                                appearance="default"
                                                size="default">
                                            {{ group.internalName }}
                                        </sw-label>
                                    </div>
                                </template>
                            {% endblock %}

                            {% block  acris_blog_list_grid_columns_rules %}
                                <template #column-publicationDate="{ item }">
                                   <sw-time-ago :date="item.publicationDate"/>
                                </template>
                            {% endblock %}

                            {% block  acris_blog_list_grid_columns_rules %}
                                <template #column-rules="{ item, isInlineEdit }">
                                    <div v-bind:class="{ 'acris-no-rule' : item.rules.length == 0}">
                                        <sw-label
                                                v-for="rule in item.rules"
                                                appearance="default"
                                                size="default">
                                            {{ rule.name }}
                                        </sw-label>
                                    </div>
                                </template>
                            {% endblock %}

                            {% block acris_blog_list_grid_columns_sales_channels %}
                                <template #column-salesChannels="{ item, isInlineEdit }">
                                    <div v-bind:class="{ 'acris-no-rule' : item.salesChannels.length == 0}">
                                        <sw-label
                                                v-for="channel in item.salesChannels"
                                                appearance="default"
                                                size="default">
                                            {{ channel.name }}
                                        </sw-label>
                                    </div>
                                </template>
                            {% endblock %}

                            {% block acris_blog_list_grid_columns_actions %}
                            <template #more-actions="{ item }">
                                {% block acris_blog_list_grid_columns_actions_duplicate %}
                                    <sw-context-menu-item
                                            class="sw-product-list-grid__duplicate-action"
                                            @click="onDuplicate(item)"
                                    >
                                        {{ $tc('sw-product.list.buttonDuplicate') }}
                                    </sw-context-menu-item>
                                {% endblock %}
                            </template>
                            {% endblock %}

                        </sw-entity-listing>
                    {% endblock %}

                    {% block acris_blog_list_empty_state %}
                        <sw-empty-state v-if="!isLoading && total === 0" :title="$tc('acris-blog.list.contentEmpty')" :show-description="false"></sw-empty-state>
                    {% endblock %}

                </div>
            </template>
        {% endblock %}

        {% block acris_blog_list_sidebar %}
            <template #sidebar>
                <sw-sidebar class="acris-blog-list__sidebar">
                    {% block acris_blog_list_sidebar_item %}
                        <sw-sidebar-item
                                icon="regular-undo"
                                :title="$tc('acris-blog.list.titleSidebarItemRefresh')"
                                @click="onRefresh">
                        </sw-sidebar-item>
                    {% endblock %}
                </sw-sidebar>
            </template>
        {% endblock %}

    </sw-page>
{% endblock %}
